/** Thèmes visuels des sites formateur LyrraOne (CSS variables + classes layout). */

export type LoSiteThemeId =
  | 'ocean'
  | 'midnight'
  | 'teal'
  | 'violet'
  | 'indigo'
  | 'ember'
  | 'forest'
  | 'rose'
  | 'corporate'
  | 'mono'
  | 'crimson'
  | 'magenta'
  | 'copper'
  | 'custom';

export interface LoSiteTheme {
  id: LoSiteThemeId;
  name: string;
  description: string;
  /** Classe racine (variables CSS) */
  rootClass: string;
  accent: string;
  accentSoft: string;
}

export const LO_SITE_THEMES: LoSiteTheme[] = [
  {
    id: 'ocean',
    name: 'Océan',
    description: 'Bleu moderne, hero lumineux — coaching & conversion.',
    rootClass: 'lo-site-theme lo-site-theme--ocean',
    accent: '#2563eb',
    accentSoft: '#dbeafe',
  },
  {
    id: 'midnight',
    name: 'Minuit',
    description: 'Sombre premium, accents indigo — executive & créatif.',
    rootClass: 'lo-site-theme lo-site-theme--midnight',
    accent: '#818cf8',
    accentSoft: '#1e293b',
  },
  {
    id: 'teal',
    name: 'Sarcelle',
    description: 'Fraîcheur pédagogique — formateurs & académies.',
    rootClass: 'lo-site-theme lo-site-theme--teal',
    accent: '#0d9488',
    accentSoft: '#ccfbf1',
  },
  {
    id: 'violet',
    name: 'Améthyste',
    description: 'Violet profond — éducation & arts.',
    rootClass: 'lo-site-theme lo-site-theme--violet',
    accent: '#7c3aed',
    accentSoft: '#ede9fe',
  },
  {
    id: 'indigo',
    name: 'Indigo tech',
    description: 'Tech & digital, contrastes nets.',
    rootClass: 'lo-site-theme lo-site-theme--indigo',
    accent: '#6366f1',
    accentSoft: '#e0e7ff',
  },
  {
    id: 'ember',
    name: 'Braise',
    description: 'Orange énergique — sport & dynamisme.',
    rootClass: 'lo-site-theme lo-site-theme--ember',
    accent: '#ea580c',
    accentSoft: '#ffedd5',
  },
  {
    id: 'copper',
    name: 'Cuivre',
    description: 'Tons chauds gastronomiques — chefs & cuisine.',
    rootClass: 'lo-site-theme lo-site-theme--copper',
    accent: '#b45309',
    accentSoft: '#fef3c7',
  },
  {
    id: 'forest',
    name: 'Forêt',
    description: 'Verts nature — bien-être, running, écologie.',
    rootClass: 'lo-site-theme lo-site-theme--forest',
    accent: '#059669',
    accentSoft: '#d1fae5',
  },
  {
    id: 'rose',
    name: 'Rose',
    description: 'Douceur moderne — pâtisserie & lifestyle.',
    rootClass: 'lo-site-theme lo-site-theme--rose',
    accent: '#db2777',
    accentSoft: '#fce7f3',
  },
  {
    id: 'crimson',
    name: 'Carmin',
    description: 'Rouge affirmé — langues & impact.',
    rootClass: 'lo-site-theme lo-site-theme--crimson',
    accent: '#dc2626',
    accentSoft: '#fee2e2',
  },
  {
    id: 'corporate',
    name: 'Corporate',
    description: 'Bleu institutionnel — consulting B2B.',
    rootClass: 'lo-site-theme lo-site-theme--corporate',
    accent: '#1e40af',
    accentSoft: '#dbeafe',
  },
  {
    id: 'magenta',
    name: 'Magenta',
    description: 'Gradient marketing audacieux.',
    rootClass: 'lo-site-theme lo-site-theme--magenta',
    accent: '#c026d3',
    accentSoft: '#fae8ff',
  },
  {
    id: 'mono',
    name: 'Monochrome',
    description: 'Noir & blanc épuré — minimal & portfolio.',
    rootClass: 'lo-site-theme lo-site-theme--mono',
    accent: '#0f172a',
    accentSoft: '#f1f5f9',
  },
];

export const LO_SITE_THEME_IDS = LO_SITE_THEMES.map((t) => t.id);

export function isLoSiteThemeId(value: unknown): value is LoSiteThemeId {
  return typeof value === 'string' && LO_SITE_THEME_IDS.includes(value as LoSiteThemeId);
}

export function getLoSiteTheme(id?: string | null): LoSiteTheme {
  if (id === 'custom') {
    return {
      id: 'custom',
      name: 'Personnalisé',
      description: 'Votre palette de couleurs sur mesure.',
      rootClass: 'lo-site-theme lo-site-theme--custom',
      accent: '#2563eb',
      accentSoft: '#dbeafe',
    };
  }
  return LO_SITE_THEMES.find((t) => t.id === id) ?? LO_SITE_THEMES[0];
}

export function getLoSiteThemeRootClass(id?: string | null): string {
  return getLoSiteTheme(id).rootClass;
}
